export default __webpack_public_path__ + "static/media/Logo.9a43ade6.png";